import Alphabet from '~/public/icons/alphabet.svg'
import Apps from '~/public/icons/apps.svg'
import ArrowBottom from '~/public/icons/arrow-bottom.svg'
import ArrowLeftRight from '~/public/icons/arrow-left-right.svg'
import ArrowLeft from '~/public/icons/arrow-left.svg'
import ArrowRight from '~/public/icons/arrow-right.svg'
import ArrowTop from '~/public/icons/arrow-top.svg'
import Ascending from '~/public/icons/ascending.svg'
import At from '~/public/icons/at.svg'
import AttachmentNa from '~/public/icons/attachment-na.svg'
import Bank from '~/public/icons/bank.svg'
import Bell from '~/public/icons/bell.svg'
import Board from '~/public/icons/board.svg'
import Book from '~/public/icons/book.svg'
import Box from '~/public/icons/box.svg'
import Bulb from '~/public/icons/bulb.svg'
import Burger from '~/public/icons/burger.svg'
import Calendar from '~/public/icons/calendar.svg'
import ChartBar from '~/public/icons/chart-bar.svg'
import Checkmark from '~/public/icons/checkmark.svg'
import ChevronDown from '~/public/icons/chevron-down.svg'
import ChevronLeft from '~/public/icons/chevron-left.svg'
import ChevronRightFilled from '~/public/icons/chevron-right-filled.svg'
import ChevronRight from '~/public/icons/chevron-right.svg'
import ChevronTop from '~/public/icons/chevron-top.svg'
import ChevronUpDown from '~/public/icons/chevron-up-down.svg'
import Clock from '~/public/icons/clock.svg'
import CloseCircleFilled from '~/public/icons/close-circle-filled.svg'
import CloseCircleUnfilled from '~/public/icons/close-circle-unfilled.svg'
import Close from '~/public/icons/close.svg'
import Code from '~/public/icons/code.svg'
import CoinDollar from '~/public/icons/coin-dollar.svg'
import Collect from '~/public/icons/collect.svg'
import Command from '~/public/icons/command.svg'
import Company from '~/public/icons/company.svg'
import Condition from '~/public/icons/condition.svg'
import ContentLeftAlign from '~/public/icons/content-left-align.svg'
import Coupon from '~/public/icons/coupon.svg'
import Descending from '~/public/icons/descending.svg'
import Document from '~/public/icons/document.svg'
import DotsHorizontal from '~/public/icons/dots-horizontal.svg'
import Download from '~/public/icons/download.svg'
import Duplicate from '~/public/icons/duplicate.svg'
import ErrorFilled from '~/public/icons/error-filled.svg'
import ErrorUnfilled from '~/public/icons/error-unfilled.svg'
import EyeHidden from '~/public/icons/eye-hidden.svg'
import Eye from '~/public/icons/eye.svg'
import Filter from '~/public/icons/filter.svg'
import FlashFilled from '~/public/icons/flash-filled.svg'
import Flash from '~/public/icons/flash.svg'
import Formulas from '~/public/icons/formulas.svg'
import Globe from '~/public/icons/globe.svg'
import Google from '~/public/icons/google.svg'
import Handle from '~/public/icons/handle.svg'
import Hashtag from '~/public/icons/hashtag.svg'
import Heart from '~/public/icons/heart.svg'
import Id from '~/public/icons/id.svg'
import InfoCircle from '~/public/icons/info-circle.svg'
import Key from '~/public/icons/key.svg'
import KeyboardEnter from '~/public/icons/keyboard-enter.svg'
import Laptop from '~/public/icons/laptop.svg'
import Lock from '~/public/icons/lock.svg'
import Logout from '~/public/icons/log-out.svg'
import MagnifyingGlass from '~/public/icons/magnifying-glass.svg'
import Mail from '~/public/icons/mail.svg'
import Map from '~/public/icons/map.svg'
import Micro from '~/public/icons/micro.svg'
import Minus from '~/public/icons/minus.svg'
import Outside from '~/public/icons/outside.svg'
import Paperclip from '~/public/icons/paperclip.svg'
import PauseCircleFilled from '~/public/icons/pause-circle-filled.svg'
import PauseCircleUnfilled from '~/public/icons/pause-circle-unfilled.svg'
import Pen from '~/public/icons/pen.svg'
import Percentage from '~/public/icons/percentage.svg'
import Pivot from '~/public/icons/pivot.svg'
import Play from '~/public/icons/play.svg'
import Plug from '~/public/icons/plug.svg'
import Plus from '~/public/icons/plus.svg'
import Processing from '~/public/icons/processing.svg'
import Pulse from '~/public/icons/pulse.svg'
import Push from '~/public/icons/push.svg'
import Puzzle from '~/public/icons/puzzle.svg'
import QuestionCircle from '~/public/icons/question-circle.svg'
import Reload from '~/public/icons/reload.svg'
import Requested from '~/public/icons/requested.svg'
import ResizeExpand from '~/public/icons/resize-expand.svg'
import ResizeReduce from '~/public/icons/resize-reduce.svg'
import Rocket from '~/public/icons/rocket.svg'
import Rotate from '~/public/icons/rotate.svg'
import Scissor from '~/public/icons/scissor.svg'
import Settings from '~/public/icons/settings.svg'
import Share from '~/public/icons/share.svg'
import Smartphone from '~/public/icons/smartphone.svg'
import Sparkles from '~/public/icons/sparkles.svg'
import StarFilled from '~/public/icons/star-filled.svg'
import Stop from '~/public/icons/stop.svg'
import SwitchOff from '~/public/icons/switch-off.svg'
import Switch from '~/public/icons/switch.svg'
import Sync from '~/public/icons/sync.svg'
import TableHorizontale from '~/public/icons/table-horizontale.svg'
import Table from '~/public/icons/table.svg'
import Target from '~/public/icons/target.svg'
import Text from '~/public/icons/text.svg'
import Trash from '~/public/icons/trash.svg'
import Unlock from '~/public/icons/unlock.svg'
import UserAdd from '~/public/icons/user-add.svg'
import UserMultiple from '~/public/icons/user-multiple.svg'
import User from '~/public/icons/user.svg'
import ValidateFilled from '~/public/icons/validate-filled.svg'
import ValidateUnfilled from '~/public/icons/validate-unfilled.svg'
import Wallet from '~/public/icons/wallet.svg'
import WarningFilled from '~/public/icons/warning-filled.svg'
import WarningUnfilled from '~/public/icons/warning-unfilled.svg'

export const ALL_ICONS = {
  at: At,
  alphabet: Alphabet,
  apps: Apps,
  'arrow-bottom': ArrowBottom,
  'arrow-left': ArrowLeft,
  'arrow-left-right': ArrowLeftRight,
  'arrow-right': ArrowRight,
  'arrow-top': ArrowTop,
  ascending: Ascending,
  'attachment-na': AttachmentNa,
  bank: Bank,
  bell: Bell,
  board: Board,
  book: Book,
  bulb: Bulb,
  burger: Burger,
  box: Box,
  calendar: Calendar,
  'chart-bar': ChartBar,
  checkmark: Checkmark,
  'chevron-down': ChevronDown,
  'chevron-left': ChevronLeft,
  'chevron-right': ChevronRight,
  'chevron-right-filled': ChevronRightFilled,
  'chevron-top': ChevronTop,
  'chevron-up-down': ChevronUpDown,
  clock: Clock,
  'close-circle-filled': CloseCircleFilled,
  'close-circle-unfilled': CloseCircleUnfilled,
  close: Close,
  code: Code,
  'coin-dollar': CoinDollar,
  collect: Collect,
  command: Command,
  company: Company,
  condition: Condition,
  'content-left-align': ContentLeftAlign,
  coupon: Coupon,
  descending: Descending,
  document: Document,
  'dots-horizontal': DotsHorizontal,
  download: Download,
  duplicate: Duplicate,
  'error-filled': ErrorFilled,
  'error-unfilled': ErrorUnfilled,
  'eye-hidden': EyeHidden,
  eye: Eye,
  filter: Filter,
  flash: Flash,
  'flash-filled': FlashFilled,
  formulas: Formulas,
  globe: Globe,
  google: Google,
  handle: Handle,
  hashtag: Hashtag,
  heart: Heart,
  id: Id,
  'info-circle': InfoCircle,
  'keyboard-enter': KeyboardEnter,
  'magnifying-glass': MagnifyingGlass,
  key: Key,
  laptop: Laptop,
  lock: Lock,
  logout: Logout,
  mail: Mail,
  map: Map,
  micro: Micro,
  minus: Minus,
  outside: Outside,
  paperclip: Paperclip,
  'pause-circle-filled': PauseCircleFilled,
  'pause-circle-unfilled': PauseCircleUnfilled,
  pen: Pen,
  percentage: Percentage,
  pivot: Pivot,
  play: Play,
  plug: Plug,
  plus: Plus,
  processing: Processing,
  pulse: Pulse,
  push: Push,
  puzzle: Puzzle,
  'question-circle': QuestionCircle,
  reload: Reload,
  requested: Requested,
  'resize-expand': ResizeExpand,
  'resize-reduce': ResizeReduce,
  rocket: Rocket,
  rotate: Rotate,
  scissor: Scissor,
  settings: Settings,
  share: Share,
  smartphone: Smartphone,
  sparkles: Sparkles,
  'star-filled': StarFilled,
  stop: Stop,
  switch: Switch,
  'switch-off': SwitchOff,
  sync: Sync,
  table: Table,
  'table-horizontale': TableHorizontale,
  target: Target,
  text: Text,
  trash: Trash,
  unlock: Unlock,
  'user-add': UserAdd,
  user: User,
  'user-multiple': UserMultiple,
  'validate-filled': ValidateFilled,
  'validate-unfilled': ValidateUnfilled,
  wallet: Wallet,
  'warning-filled': WarningFilled,
  'warning-unfilled': WarningUnfilled,
}
